import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TLeadStatus } from '@shared/types/lead-status';

type TLeadStatusQuery = {
  status?: string;
} & Omit<TBaseQuery, 'name'>;

const leadStatusApi = createCrudService<TLeadStatus, TLeadStatusQuery>({
  queryKey: [QUERY_KEYS.getStatusesList],
  url: 'lead-statuses',
});

export default leadStatusApi;
